import React from 'react';
import HOC from '../../routes/HOC';

const Confirm = props => {
    const text = {
        question: props.question || "Biztosan felakarja oldalni az asztalt?",
        agree: props.agree || "Igen",
        disagree: props.disagree || "Nem",
    }
    /* if (typeof props.debug !== 'undefined')
      console.log(props.debug)
    */
    return (
        <HOC>
            <p>{text.question}</p>
            <div className="row">
                <div className="col-6">
                    <button className="cursor_pointer button active bold" onClick={() => props.agreeHandler()}>{text.agree}</button>
                </div>
                <div className="col-6">
                    <button className="cursor_pointer button bold" onClick={() => props.disagreeHandler()}>{text.disagree}</button>
                </div>
            </div>
        </HOC>
    )
}
export default Confirm;



// WEBPACK FOOTER //
// ./src/components/Confirm/index.js